import React from 'react';

type LoadingScreenProps = {
  title?: string;
  copy?: string;
  inline?: boolean;
  message?: string;
};

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  title,
  copy = '잠시만 기다려 주세요.',
  inline = false,
  message,
}) => {
  const resolvedTitle = title || message || '로딩 중';

  if (inline) {
    return (
      <div className="loading-inline" role="status" aria-live="polite" aria-busy="true">
        <div className="loading-spinner" aria-hidden="true" />
        <div>
          <div className="loading-title">{resolvedTitle}</div>
          <div className="loading-copy">{copy}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="loading-screen" role="status" aria-live="polite" aria-busy="true">
      <div className="loading-panel">
        <div className="loading-spinner" aria-hidden="true" />
        <div className="loading-title">{resolvedTitle}</div>
        <div className="loading-copy">{copy}</div>
        <div className="loading-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
